export default {
  concedentes_contatos: [],
  concedente_contato: {},
  pagination: {
    current_page: 1,
    per_page: 15,
  },
  is_loading: false,
};
